import React from 'react';
import { useWeb3 } from '../context/Web3Context';
import './NetworkWarning.css';

function NetworkWarning() {
  const { isWrongNetwork, switchToBase, isConnected } = useWeb3();

  if (!isConnected || !isWrongNetwork) return null;

  return (
    <div className="network-warning">
      <div className="network-warning-content">
        <span className="network-warning-icon">⚠️</span>
        <span className="network-warning-text">Wrong Network - Please switch to Base</span>
      </div>
      <button className="switch-network-btn" onClick={switchToBase}>
        Switch to Base
      </button>
    </div>
  );
}

export default NetworkWarning;
